module.exports = __webpack_public_path__ + "static/media/BAHNSCHRIF_Regular.b3483ec6.TTF";